import WidgetModel from '../widget-model'
import EmbeddedContentView from './embedded-content-view'
import fileInfo from 'scoreboard/components/files/file-info'

/**
 * Backbone.Model for embedded-content widgets
 */
const EmbeddedContent = WidgetModel.extend({
	viewCls: EmbeddedContentView,

	containerDefaults: {
		width: 480,
		height: 330
	},

	isImage() {
		return fileInfo.type(this.src()) === 'image'
	},

	src() {
		return this.properties.get('url')
	}
})

export default EmbeddedContent

EmbeddedContent.__filename__ = 'dashboards/widgets/embedded-content/embedded-content-model.js'
